import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_11788",
		"data-name": "Group 11788",
		transform: "translate(-0.217 0.199)",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_573",
			"data-name": "Ellipse 573",
			cx: 30,
			cy: 30,
			r: 30,
			transform: "translate(0.217 -0.199)",
			fill: "#fff",
			opacity: .67
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_11785",
			"data-name": "Group 11785",
			transform: "translate(13.217 15.801)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group_1192",
				"data-name": "Group 1192",
				transform: "translate(0)",
				children: [
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1191",
						"data-name": "Group 1191",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Path_1263",
								"data-name": "Path 1263",
								d: "M1064.648,2033.152a2.228,2.228,0,0,1-2.162,2.29h-28.824a2.229,2.229,0,0,1-2.162-2.29V2011.79a2.229,2.229,0,0,1,2.162-2.29h28.824a2.228,2.228,0,0,1,2.162,2.29Z",
								transform: "translate(-1031.5 -2009.5)",
								fill: "#dad9ef",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							}),
							/* @__PURE__ */ _jsx("line", {
								id: "Line_173",
								"data-name": "Line 173",
								x2: 20.177,
								transform: "translate(6.485 28.824)",
								fill: "none",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							}),
							/* @__PURE__ */ _jsx("line", {
								id: "Line_174",
								"data-name": "Line 174",
								y2: 2.882,
								transform: "translate(15.853 25.942)",
								fill: "none",
								stroke: "#7284fa",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 1
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_47",
								"data-name": "Ellipse 47",
								cx: .447,
								cy: .447,
								rx: .447,
								ry: .447,
								transform: "translate(15.407 22.333)",
								fill: "#dad9ef",
								stroke: "#7284fa",
								strokeLinejoin: "round",
								strokeWidth: 1
							}),
							/* @__PURE__ */ _jsx("line", {
								id: "Line_175",
								"data-name": "Line 175",
								x2: 33.148,
								transform: "translate(0 20.177)",
								fill: "none",
								stroke: "#7284fa",
								strokeLinejoin: "round",
								strokeWidth: 1
							})
						]
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_48",
						"data-name": "Ellipse 48",
						cx: 7.206,
						cy: 7.206,
						r: 7.206,
						transform: "translate(3.603 2.882)",
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1264",
						"data-name": "Path 1264",
						d: "M1043.074,2012.376,1039,2018.32l4.619,5.528",
						transform: "translate(-1028.191 -2008.231)",
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_176",
						"data-name": "Line 176",
						x1: 7.206,
						transform: "translate(3.603 10.088)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_177",
						"data-name": "Line 177",
						x2: 8.068,
						transform: "translate(20.896 4.324)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_178",
						"data-name": "Line 178",
						x2: 8.068,
						transform: "translate(20.896 8.647)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_179",
						"data-name": "Line 179",
						x2: 8.068,
						transform: "translate(20.896 12.971)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					})
				]
			})
		})]
	})
});
export default SvgScreen;
